export default __webpack_public_path__ + "static/media/step3.74a1b38e.png";